'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reflux = require('reflux');

var _reflux2 = _interopRequireDefault(_reflux);

var _Actions = require('../Actions');

var _Actions2 = _interopRequireDefault(_Actions);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import SchedulerStore from "./scheduler-store";


var TipStore = _reflux2.default.createStore({
    listenables: [_Actions2.default],
    init: function init() {
        this._tip = 0;
        this._tipPercent = null;
        this._tipType = null;
    },


    // Add tip
    addTip: function addTip(tip, tipType, tipPercent) {
        this._tip = tip;
        this._tipType = tipType;
        this._tipPercent = tipPercent;

        this.triggerTipChange();
    },


    // Remove tip
    removeTip: function removeTip() {

        // console.log("removed tip")

        this._tip = 0;
        this._tipType = null;
        this._tipPercent = null;

        this.triggerTipChange();
    },
    refreshTip: function refreshTip() {
        this.triggerTipChange();
    },
    triggerTipChange: function triggerTipChange() {
        var tipObj = {
            tip: this._tip,
            tipType: this._tipType,
            tipPercent: this._tipPercent
        };
        this.trigger('change', tipObj);
    }
});
exports.default = TipStore;


//////////////////
// WEBPACK FOOTER
// ./src/stores/TipStore.jsx
// module id = 417
// module chunks = 0